import type { PostalAddress } from '@app/icare/db/schema/common'

export const getGoogleMapsUrl = (address: PostalAddress): string => {
  const addressParts = [address.streetAddress, address.zipCode, address.city].filter(Boolean)

  const searchQuery = encodeURIComponent(addressParts.join(', '))
  return `https://www.google.com/maps/search/?api=1&query=${searchQuery}`
}
